import { render, staticRenderFns } from "./campaign_mail.vue?vue&type=template&id=3be4634e"
import script from "./campaign_mail.vue?vue&type=script&lang=js"
export * from "./campaign_mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports